import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteProduct from 'hooks/product/useDeleteProduct';
import { ProductRetrieve } from 'types';
import notificationHandler from 'utils/notifications';

const ModalRetailDelete = ({
  opened,
  retail,
  handleClose,
  handleClearCart,
}: {
  opened: boolean;
  handleClose: () => void;
  retail: ProductRetrieve;
  handleClearCart: () => void;
}): JSX.Element => {
  const { mutate, isLoading } = useDeleteProduct();

  const { successNotification, errorNotification } = notificationHandler();

  const handleDelete = (): void => {
    mutate(retail.productId, {
      onSuccess: () => {
        successNotification('Retail delete success', `${retail.name} successfully deleted.`);
        handleClearCart();
      },
      onError: error => {
        errorNotification('Retail delete failed', error.response?.data.message);
      },
      onSettled: () => {
        handleClose();
      },
    });
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Retail Item</Title>}
      size='md'
    >
      <Stack>
        <Text>{`Are you sure you want to delete ${retail.name}?`}</Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button onClick={handleDelete} color='red' loading={isLoading} data-cy='confirmDeleteItem'>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalRetailDelete;
